let countries: any = [
  {
    country_label: "Saudi Arabia",
    code: "SA",
    unicode: "&#x1F1F8;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SA.svg",
    label: "+966"
  },
  {
    country_label: "United Arab Emirates",
    code: "AE",
    unicode: "&#x1F1E6;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AE.svg",
    label: "+971"
  },
  {
    country_label: "Bahrain",
    code: "BH",
    unicode: "&#x1F1E7;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BH.svg",
    label: "+973"
  },
  {
    country_label: "Kuwait",
    code: "KW",
    unicode: "&#x1F1F0;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KW.svg",
    label: "+965"
  },
  {
    country_label: "Qatar",
    code: "QA",
    unicode: "&#x1F1F6;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/QA.svg",
    label: "+974"
  },
  {
    country_label: "Oman",
    code: "OM",
    unicode: "&#x1F1F4;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/OM.svg",
    label: "+968"
  },
  {
    country_label: "Andorra",
    value: "Andorra",
    code: "AD",
    unicode: "&#x1F1E6;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AD.svg",
    label: "+376"
  },

  {
    country_label: "Afghanistan",
    code: "AF",
    unicode: "&#x1F1E6;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AF.svg",
    label: "+93"
  },
  {
    country_label: "Antigua & Barbuda",
    code: "AG",
    unicode: "&#x1F1E6;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AG.svg",
    label: "+1268"
  },
  {
    country_label: "Anguilla",
    code: "AI",
    unicode: "&#x1F1E6;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AI.svg",
    label: "+1264"
  },
  {
    country_label: "Albania",
    code: "AL",
    unicode: "&#x1F1E6;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AL.svg",
    label: "+355"
  },
  {
    country_label: "Armenia",
    code: "AM",
    unicode: "&#x1F1E6;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AM.svg",
    label: "+374"
  },
  {
    country_label: "Angola",
    code: "AO",
    unicode: "&#x1F1E6;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AO.svg",
    label: "+244"
  },
  {
    country_label: "Antarctica",
    code: "AQ",
    unicode: "&#x1F1E6;&#x1F1F6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AQ.svg",
    label: "+672"
  },
  {
    country_label: "Argentina",
    code: "AR",
    unicode: "&#x1F1E6;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AR.svg",
    label: "+54"
  },
  {
    country_label: "American Samoa",
    code: "AS",
    unicode: "&#x1F1E6;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AS.svg",
    label: "+1684"
  },
  {
    country_label: "Austria",
    code: "AT",
    unicode: "&#x1F1E6;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AT.svg",
    label: "+43"
  },
  {
    country_label: "Australia",
    code: "AU",
    unicode: "&#x1F1E6;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AU.svg",
    label: "+61"
  },
  {
    country_label: "Aruba",
    code: "AW",
    unicode: "&#x1F1E6;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AW.svg",
    label: "+297"
  },
  {
    country_label: "Åland Islands",
    code: "AX",
    unicode: "&#x1F1E6;&#x1F1FD;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AX.svg",
    label: "+358"
  },
  {
    country_label: "Azerbaijan",
    code: "AZ",
    unicode: "&#x1F1E6;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/AZ.svg",
    label: "+994"
  },
  {
    country_label: "Bosnia & Herzegovina",
    code: "BA",
    unicode: "&#x1F1E7;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BA.svg",
    label: "+387"
  },
  {
    country_label: "Barbados",
    code: "BB",
    unicode: "&#x1F1E7;&#x1F1E7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BB.svg",
    label: "+1246"
  },
  {
    country_label: "Bangladesh",
    code: "BD",
    unicode: "&#x1F1E7;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BD.svg",
    label: "+880"
  },
  {
    country_label: "Belgium",
    code: "BE",
    unicode: "&#x1F1E7;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BE.svg",
    label: "+32"
  },
  {
    country_label: "Burkina Faso",
    code: "BF",
    unicode: "&#x1F1E7;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BF.svg",
    label: "+226"
  },
  {
    country_label: "Bulgaria",
    code: "BG",
    unicode: "&#x1F1E7;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BG.svg",
    label: "+359"
  },

  {
    country_label: "Burundi",
    code: "BI",
    unicode: "&#x1F1E7;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BI.svg",
    label: "+257"
  },
  {
    country_label: "Benin",
    code: "BJ",
    unicode: "&#x1F1E7;&#x1F1EF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BJ.svg",
    label: "+229"
  },
  {
    country_label: "St. Barthélemy",
    code: "BL",
    unicode: "&#x1F1E7;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BL.svg",
    label: "+590"
  },
  {
    country_label: "Bermuda",
    code: "BM",
    unicode: "&#x1F1E7;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BM.svg",
    label: "+1441"
  },
  {
    country_label: "Brunei",
    code: "BN",
    unicode: "&#x1F1E7;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BN.svg",
    label: "+673"
  },
  {
    country_label: "Bolivia",
    code: "BO",
    unicode: "&#x1F1E7;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BO.svg",
    label: "+591"
  },
  {
    country_label: "Brazil",
    code: "BR",
    unicode: "&#x1F1E7;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BR.svg",
    label: "+55"
  },
  {
    country_label: "Bahamas",
    code: "BS",
    unicode: "&#x1F1E7;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BS.svg",
    label: "+1242"
  },
  {
    country_label: "Bhutan",
    code: "BT",
    unicode: "&#x1F1E7;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BT.svg",
    label: "+975"
  },
  {
    country_label: "Botswana",
    code: "BW",
    unicode: "&#x1F1E7;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BW.svg",
    label: "+267"
  },
  {
    country_label: "Belarus",
    code: "BY",
    unicode: "&#x1F1E7;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BY.svg",
    label: "+375"
  },
  {
    country_label: "Belize",
    code: "BZ",
    unicode: "&#x1F1E7;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/BZ.svg",
    label: "+501"
  },
  {
    country_label: "Canada",
    code: "CA",
    unicode: "&#x1F1E8;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CA.svg",
    label: "+1"
  },
  {
    country_label: "Cocos (Keeling) Islands",
    code: "CC",
    unicode: "&#x1F1E8;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CC.svg",
    label: "+61"
  },
  {
    country_label: "Congo - Kinshasa",
    code: "CD",
    unicode: "&#x1F1E8;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CD.svg",
    label: "+243"
  },
  {
    country_label: "Central African Republic",
    code: "CF",
    unicode: "&#x1F1E8;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CF.svg",
    label: "+236"
  },
  {
    country_label: "Congo - Brazzaville",
    code: "CG",
    unicode: "&#x1F1E8;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CG.svg",
    label: "+242"
  },
  {
    country_label: "Switzerland",
    code: "CH",
    unicode: "&#x1F1E8;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CH.svg",
    label: "+41"
  },
  {
    country_label: "Côte d’Ivoire",
    code: "CI",
    unicode: "&#x1F1E8;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CI.svg",
    label: "+225"
  },
  {
    country_label: "Cook Islands",
    code: "CK",
    unicode: "&#x1F1E8;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CK.svg",
    label: "+682"
  },
  {
    country_label: "Chile",
    code: "CL",
    unicode: "&#x1F1E8;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CL.svg",
    label: "+56"
  },
  {
    country_label: "Cameroon",
    code: "CM",
    unicode: "&#x1F1E8;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CM.svg",
    label: "+237"
  },
  {
    country_label: "China",
    code: "CN",
    unicode: "&#x1F1E8;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CN.svg",
    label: "+86"
  },
  {
    country_label: "Colombia",
    code: "CO",
    unicode: "&#x1F1E8;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CO.svg",
    label: "+57"
  },
  {
    country_label: "Costa Rica",
    code: "CR",
    unicode: "&#x1F1E8;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CR.svg",
    label: "+506"
  },
  {
    country_label: "Cuba",
    code: "CU",
    unicode: "&#x1F1E8;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CU.svg",
    label: "+53"
  },
  {
    country_label: "Cape Verde",
    code: "CV",
    unicode: "&#x1F1E8;&#x1F1FB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CV.svg",
    label: "+238"
  },
  {
    country_label: "Christmas Island",
    code: "CX",
    unicode: "&#x1F1E8;&#x1F1FD;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CX.svg",
    label: "+61"
  },
  {
    country_label: "Cyprus",
    code: "CY",
    unicode: "&#x1F1E8;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CY.svg",
    label: "+357"
  },
  {
    country_label: "Czechia",
    code: "CZ",
    unicode: "&#x1F1E8;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/CZ.svg",
    label: "+420"
  },
  {
    country_label: "Germany",
    code: "DE",
    unicode: "&#x1F1E9;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DE.svg",
    label: "+49"
  },
  {
    country_label: "Djibouti",
    code: "DJ",
    unicode: "&#x1F1E9;&#x1F1EF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DJ.svg",
    label: "+253"
  },
  {
    country_label: "Denmark",
    code: "DK",
    unicode: "&#x1F1E9;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DK.svg",
    label: "+45"
  },
  {
    country_label: "Dominica",
    code: "DM",
    unicode: "&#x1F1E9;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DM.svg",
    label: "+1767"
  },
  {
    country_label: "Dominican Republic",
    code: "DO",
    unicode: "&#x1F1E9;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DO.svg",
    label: "+1849"
  },
  {
    country_label: "Algeria",
    code: "DZ",
    unicode: "&#x1F1E9;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/DZ.svg",
    label: "+213"
  },
  {
    country_label: "Ecuador",
    code: "EC",
    unicode: "&#x1F1EA;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EC.svg",
    label: "+593"
  },
  {
    country_label: "Estonia",
    code: "EE",
    unicode: "&#x1F1EA;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EE.svg",
    label: "+372"
  },
  {
    country_label: "Egypt",
    code: "EG",
    unicode: "&#x1F1EA;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/EG.svg",
    label: "+20"
  },
  {
    country_label: "Eritrea",
    code: "ER",
    unicode: "&#x1F1EA;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ER.svg",
    label: "+291"
  },
  {
    country_label: "Spain",
    code: "ES",
    unicode: "&#x1F1EA;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ES.svg",
    label: "+34"
  },
  {
    country_label: "Ethiopia",
    code: "ET",
    unicode: "&#x1F1EA;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ET.svg",
    label: "+251"
  },
  {
    country_label: "Finland",
    code: "FI",
    unicode: "&#x1F1EB;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FI.svg",
    label: "+358"
  },
  {
    country_label: "Fiji",
    code: "FJ",
    unicode: "&#x1F1EB;&#x1F1EF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FJ.svg",
    label: "+679"
  },
  {
    country_label: "Falkland Islands",
    code: "FK",
    unicode: "&#x1F1EB;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FK.svg",
    label: "+500"
  },
  {
    country_label: "Micronesia",
    code: "FM",
    unicode: "&#x1F1EB;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FM.svg",
    label: "+691"
  },
  {
    country_label: "Faroe Islands",
    code: "FO",
    unicode: "&#x1F1EB;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FO.svg",
    label: "+298"
  },
  {
    country_label: "France",
    code: "FR",
    unicode: "&#x1F1EB;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/FR.svg",
    label: "+33"
  },
  {
    country_label: "Gabon",
    code: "GA",
    unicode: "&#x1F1EC;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GA.svg",
    label: "+241"
  },
  {
    country_label: "United Kingdom",
    code: "GB",
    unicode: "&#x1F1EC;&#x1F1E7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GB.svg",
    label: "+44"
  },
  {
    country_label: "Grenada",
    code: "GD",
    unicode: "&#x1F1EC;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GD.svg",
    label: "+1473"
  },
  {
    country_label: "Georgia",
    code: "GE",
    unicode: "&#x1F1EC;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GE.svg",
    label: "+995"
  },
  {
    country_label: "French Guiana",
    code: "GF",
    unicode: "&#x1F1EC;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GF.svg",
    label: "+594"
  },
  {
    country_label: "Guernsey",
    code: "GG",
    unicode: "&#x1F1EC;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GG.svg",
    label: "+44"
  },
  {
    country_label: "Ghana",
    code: "GH",
    unicode: "&#x1F1EC;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GH.svg",
    label: "+233"
  },
  {
    country_label: "Gibraltar",
    code: "GI",
    unicode: "&#x1F1EC;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GI.svg",
    label: "+350"
  },
  {
    country_label: "Greenland",
    code: "GL",
    unicode: "&#x1F1EC;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GL.svg",
    label: "+299"
  },
  {
    country_label: "Gambia",
    code: "GM",
    unicode: "&#x1F1EC;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GM.svg",
    label: "+220"
  },
  {
    country_label: "Guinea",
    code: "GN",
    unicode: "&#x1F1EC;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GN.svg",
    label: "+224"
  },
  {
    country_label: "Guadeloupe",
    code: "GP",
    unicode: "&#x1F1EC;&#x1F1F5;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GP.svg",
    label: "+590"
  },
  {
    country_label: "Equatorial Guinea",
    code: "GQ",
    unicode: "&#x1F1EC;&#x1F1F6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GQ.svg",
    label: "+240"
  },
  {
    country_label: "Greece",
    code: "GR",
    unicode: "&#x1F1EC;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GR.svg",
    label: "+30"
  },
  {
    country_label: "South Georgia & South Sandwich Islands",
    code: "GS",
    unicode: "&#x1F1EC;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GS.svg",
    label: "+500"
  },
  {
    country_label: "Guatemala",
    code: "GT",
    unicode: "&#x1F1EC;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GT.svg",
    label: "+502"
  },
  {
    country_label: "Guam",
    code: "GU",
    unicode: "&#x1F1EC;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GU.svg",
    label: "+1671"
  },
  {
    country_label: "Guinea-Bissau",
    code: "GW",
    unicode: "&#x1F1EC;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GW.svg",
    label: "+245"
  },
  {
    country_label: "Guyana",
    code: "GY",
    unicode: "&#x1F1EC;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/GY.svg",
    label: "+595"
  },
  {
    country_label: "Hong Kong SAR China",
    code: "HK",
    unicode: "&#x1F1ED;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HK.svg",
    label: "+852"
  },
  {
    country_label: "Honduras",
    code: "HN",
    unicode: "&#x1F1ED;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HN.svg",
    label: "+504"
  },
  {
    country_label: "Croatia",
    code: "HR",
    unicode: "&#x1F1ED;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HR.svg",
    label: "+385"
  },
  {
    country_label: "Haiti",
    code: "HT",
    unicode: "&#x1F1ED;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HT.svg",
    label: "+509"
  },
  {
    country_label: "Hungary",
    code: "HU",
    unicode: "&#x1F1ED;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/HU.svg",
    label: "+36"
  },
  {
    country_label: "Indonesia",
    code: "ID",
    unicode: "&#x1F1EE;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ID.svg",
    label: "+62"
  },
  {
    country_label: "Ireland",
    code: "IE",
    unicode: "&#x1F1EE;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IE.svg",
    label: "+353"
  },
  {
    country_label: "Israel",
    code: "IL",
    unicode: "&#x1F1EE;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IL.svg",
    label: "+972"
  },
  {
    country_label: "Isle of Man",
    code: "IM",
    unicode: "&#x1F1EE;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IM.svg",
    label: "+44"
  },
  {
    country_label: "India",
    code: "IN",
    unicode: "&#x1F1EE;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IN.svg",
    label: "+91"
  },
  {
    country_label: "British Indian Ocean Territory",
    code: "IO",
    unicode: "&#x1F1EE;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IO.svg",
    label: "+246"
  },
  {
    country_label: "Iraq",
    code: "IQ",
    unicode: "&#x1F1EE;&#x1F1F6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IQ.svg",
    label: "+964"
  },
  {
    country_label: "Iran",
    code: "IR",
    unicode: "&#x1F1EE;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IR.svg",
    label: "+98"
  },
  {
    country_label: "Iceland",
    code: "IS",
    unicode: "&#x1F1EE;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IS.svg",
    label: "+354"
  },
  {
    country_label: "Italy",
    code: "IT",
    unicode: "&#x1F1EE;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/IT.svg",
    label: "+39"
  },
  {
    country_label: "Jersey",
    code: "JE",
    unicode: "&#x1F1EF;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JE.svg",
    label: "+44"
  },
  {
    country_label: "Jamaica",
    code: "JM",
    unicode: "&#x1F1EF;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JM.svg",
    label: "+1876"
  },
  {
    country_label: "Jordan",
    code: "JO",
    unicode: "&#x1F1EF;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JO.svg",
    label: "+962"
  },
  {
    country_label: "Japan",
    code: "JP",
    unicode: "&#x1F1EF;&#x1F1F5;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/JP.svg",
    label: "+81"
  },
  {
    country_label: "Kenya",
    code: "KE",
    unicode: "&#x1F1F0;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KE.svg",
    label: "+254"
  },
  {
    country_label: "Kyrgyzstan",
    code: "KG",
    unicode: "&#x1F1F0;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KG.svg",
    label: "+996"
  },
  {
    country_label: "Cambodia",
    code: "KH",
    unicode: "&#x1F1F0;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KH.svg",
    label: "+855"
  },
  {
    country_label: "Kiribati",
    code: "KI",
    unicode: "&#x1F1F0;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KI.svg",
    label: "+686"
  },
  {
    country_label: "Comoros",
    code: "KM",
    unicode: "&#x1F1F0;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KM.svg",
    label: "+269"
  },
  {
    country_label: "St. Kitts & Nevis",
    code: "KN",
    unicode: "&#x1F1F0;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KN.svg",
    label: "+1869"
  },
  {
    country_label: "North Korea",
    code: "KP",
    unicode: "&#x1F1F0;&#x1F1F5;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KP.svg",
    label: "+850"
  },
  {
    country_label: "South Korea",
    code: "KR",
    unicode: "&#x1F1F0;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KR.svg",
    label: "+82"
  },

  {
    country_label: "Cayman Islands",
    code: "KY",
    unicode: "&#x1F1F0;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KY.svg",
    label: "+ 345"
  },
  {
    country_label: "Kazakhstan",
    code: "KZ",
    unicode: "&#x1F1F0;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/KZ.svg",
    label: "+77"
  },
  {
    country_label: "Laos",
    code: "LA",
    unicode: "&#x1F1F1;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LA.svg",
    label: "+856"
  },
  {
    country_label: "Lebanon",
    code: "LB",
    unicode: "&#x1F1F1;&#x1F1E7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LB.svg",
    label: "+961"
  },
  {
    country_label: "St. Lucia",
    code: "LC",
    unicode: "&#x1F1F1;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LC.svg",
    label: "+1758"
  },
  {
    country_label: "Liechtenstein",
    code: "LI",
    unicode: "&#x1F1F1;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LI.svg",
    label: "+423"
  },
  {
    country_label: "Sri Lanka",
    code: "LK",
    unicode: "&#x1F1F1;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LK.svg",
    label: "+94"
  },
  {
    country_label: "Liberia",
    code: "LR",
    unicode: "&#x1F1F1;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LR.svg",
    label: "+231"
  },
  {
    country_label: "Lesotho",
    code: "LS",
    unicode: "&#x1F1F1;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LS.svg",
    label: "+266"
  },
  {
    country_label: "Lithuania",
    code: "LT",
    unicode: "&#x1F1F1;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LT.svg",
    label: "+370"
  },
  {
    country_label: "Luxembourg",
    code: "LU",
    unicode: "&#x1F1F1;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LU.svg",
    label: "+352"
  },
  {
    country_label: "Latvia",
    code: "LV",
    unicode: "&#x1F1F1;&#x1F1FB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LV.svg",
    label: "+371"
  },
  {
    country_label: "Libya",
    code: "LY",
    unicode: "&#x1F1F1;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/LY.svg",
    label: "+218"
  },
  {
    country_label: "Morocco",
    code: "MA",
    unicode: "&#x1F1F2;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MA.svg",
    label: "+212"
  },
  {
    country_label: "Monaco",
    code: "MC",
    unicode: "&#x1F1F2;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MC.svg",
    label: "+377"
  },
  {
    country_label: "Moldova",
    code: "MD",
    unicode: "&#x1F1F2;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MD.svg",
    label: "+373"
  },
  {
    country_label: "Montenegro",
    code: "ME",
    unicode: "&#x1F1F2;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ME.svg",
    label: "+382"
  },
  {
    country_label: "St. Martin",
    code: "MF",
    unicode: "&#x1F1F2;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MF.svg",
    label: "+590"
  },
  {
    country_label: "Madagascar",
    code: "MG",
    unicode: "&#x1F1F2;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MG.svg",
    label: "+261"
  },
  {
    country_label: "Marshall Islands",
    code: "MH",
    unicode: "&#x1F1F2;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MH.svg",
    label: "+692"
  },
  {
    country_label: "North Macedonia",
    code: "MK",
    unicode: "&#x1F1F2;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MK.svg",
    label: "+389"
  },
  {
    country_label: "Mali",
    code: "ML",
    unicode: "&#x1F1F2;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ML.svg",
    label: "+223"
  },
  {
    country_label: "Myanmar (Burma)",
    code: "MM",
    unicode: "&#x1F1F2;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MM.svg",
    label: "+95"
  },
  {
    country_label: "Mongolia",
    code: "MN",
    unicode: "&#x1F1F2;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MN.svg",
    label: "+976"
  },
  {
    country_label: "Macao SAR China",
    code: "MO",
    unicode: "&#x1F1F2;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MO.svg",
    label: "+853"
  },
  {
    country_label: "Northern Mariana Islands",
    code: "MP",
    unicode: "&#x1F1F2;&#x1F1F5;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MP.svg",
    label: "+1670"
  },
  {
    country_label: "Martinique",
    code: "MQ",
    unicode: "&#x1F1F2;&#x1F1F6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MQ.svg",
    label: "+596"
  },
  {
    country_label: "Mauritania",
    code: "MR",
    unicode: "&#x1F1F2;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MR.svg",
    label: "+222"
  },
  {
    country_label: "Montserrat",
    code: "MS",
    unicode: "&#x1F1F2;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MS.svg",
    label: "+1664"
  },
  {
    country_label: "Malta",
    code: "MT",
    unicode: "&#x1F1F2;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MT.svg",
    label: "+356"
  },
  {
    country_label: "Mauritius",
    code: "MU",
    unicode: "&#x1F1F2;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MU.svg",
    label: "+230"
  },
  {
    country_label: "Maldives",
    code: "MV",
    unicode: "&#x1F1F2;&#x1F1FB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MV.svg",
    label: "+960"
  },
  {
    country_label: "Malawi",
    code: "MW",
    unicode: "&#x1F1F2;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MW.svg",
    label: "+265"
  },
  {
    country_label: "Mexico",
    code: "MX",
    unicode: "&#x1F1F2;&#x1F1FD;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MX.svg",
    label: "+52"
  },
  {
    country_label: "Malaysia",
    code: "MY",
    unicode: "&#x1F1F2;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MY.svg",
    label: "+60"
  },
  {
    country_label: "Mozambique",
    code: "MZ",
    unicode: "&#x1F1F2;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/MZ.svg",
    label: "+258"
  },
  {
    country_label: "Namibia",
    code: "NA",
    unicode: "&#x1F1F3;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NA.svg",
    label: "+264"
  },
  {
    country_label: "New Caledonia",
    code: "NC",
    unicode: "&#x1F1F3;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NC.svg",
    label: "+687"
  },
  {
    country_label: "Niger",
    code: "NE",
    unicode: "&#x1F1F3;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NE.svg",
    label: "+227"
  },
  {
    country_label: "Norfolk Island",
    code: "NF",
    unicode: "&#x1F1F3;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NF.svg",
    label: "+672"
  },
  {
    country_label: "Nigeria",
    code: "NG",
    unicode: "&#x1F1F3;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NG.svg",
    label: "+234"
  },
  {
    country_label: "Nicaragua",
    code: "NI",
    unicode: "&#x1F1F3;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NI.svg",
    label: "+505"
  },
  {
    country_label: "Netherlands",
    code: "NL",
    unicode: "&#x1F1F3;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NL.svg",
    label: "+31"
  },
  {
    country_label: "Norway",
    code: "NO",
    unicode: "&#x1F1F3;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NO.svg",
    label: "+47"
  },
  {
    country_label: "Nepal",
    code: "NP",
    unicode: "&#x1F1F3;&#x1F1F5;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NP.svg",
    label: "+977"
  },
  {
    country_label: "Nauru",
    code: "NR",
    unicode: "&#x1F1F3;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NR.svg",
    label: "+674"
  },
  {
    country_label: "Niue",
    code: "NU",
    unicode: "&#x1F1F3;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NU.svg",
    label: "+683"
  },
  {
    country_label: "New Zealand",
    code: "NZ",
    unicode: "&#x1F1F3;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/NZ.svg",
    label: "+64"
  },

  {
    country_label: "Panama",
    code: "PA",
    unicode: "&#x1F1F5;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PA.svg",
    label: "+507"
  },
  {
    country_label: "Peru",
    code: "PE",
    unicode: "&#x1F1F5;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PE.svg",
    label: "+51"
  },
  {
    country_label: "French Polynesia",
    code: "PF",
    unicode: "&#x1F1F5;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PF.svg",
    label: "+689"
  },
  {
    country_label: "Papua New Guinea",
    code: "PG",
    unicode: "&#x1F1F5;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PG.svg",
    label: "+675"
  },
  {
    country_label: "Philippines",
    code: "PH",
    unicode: "&#x1F1F5;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PH.svg",
    label: "+63"
  },
  {
    country_label: "Pakistan",
    code: "PK",
    unicode: "&#x1F1F5;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PK.svg",
    label: "+92"
  },
  {
    country_label: "Poland",
    code: "PL",
    unicode: "&#x1F1F5;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PL.svg",
    label: "+48"
  },
  {
    country_label: "St. Pierre & Miquelon",
    code: "PM",
    unicode: "&#x1F1F5;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PM.svg",
    label: "+508"
  },
  {
    country_label: "Pitcairn Islands",
    code: "PN",
    unicode: "&#x1F1F5;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PN.svg",
    label: "+872"
  },
  {
    country_label: "Puerto Rico",
    code: "PR",
    unicode: "&#x1F1F5;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PR.svg",
    label: "+1939"
  },
  {
    country_label: "Palestinian Territories",
    code: "PS",
    unicode: "&#x1F1F5;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PS.svg",
    label: "+970"
  },
  {
    country_label: "Portugal",
    code: "PT",
    unicode: "&#x1F1F5;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PT.svg",
    label: "+351"
  },
  {
    country_label: "Palau",
    code: "PW",
    unicode: "&#x1F1F5;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PW.svg",
    label: "+680"
  },
  {
    country_label: "Paraguay",
    code: "PY",
    unicode: "&#x1F1F5;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/PY.svg",
    label: "+595"
  },

  {
    country_label: "Réunion",
    code: "RE",
    unicode: "&#x1F1F7;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RE.svg",
    label: "+262"
  },
  {
    country_label: "Romania",
    code: "RO",
    unicode: "&#x1F1F7;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RO.svg",
    label: "+40"
  },
  {
    country_label: "Serbia",
    code: "RS",
    unicode: "&#x1F1F7;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RS.svg",
    label: "+381"
  },
  {
    country_label: "Russia",
    code: "RU",
    unicode: "&#x1F1F7;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RU.svg",
    label: "+7"
  },
  {
    country_label: "Rwanda",
    code: "RW",
    unicode: "&#x1F1F7;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/RW.svg",
    label: "+250"
  },

  {
    country_label: "Solomon Islands",
    code: "SB",
    unicode: "&#x1F1F8;&#x1F1E7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SB.svg",
    label: "+677"
  },
  {
    country_label: "Seychelles",
    code: "SC",
    unicode: "&#x1F1F8;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SC.svg",
    label: "+248"
  },
  {
    country_label: "Sudan",
    code: "SD",
    unicode: "&#x1F1F8;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SD.svg",
    label: "+249"
  },
  {
    country_label: "Sweden",
    code: "SE",
    unicode: "&#x1F1F8;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SE.svg",
    label: "+46"
  },
  {
    country_label: "Singapore",
    code: "SG",
    unicode: "&#x1F1F8;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SG.svg",
    label: "+65"
  },
  {
    country_label: "St. Helena",
    code: "SH",
    unicode: "&#x1F1F8;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SH.svg",
    label: "+290"
  },
  {
    country_label: "Slovenia",
    code: "SI",
    unicode: "&#x1F1F8;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SI.svg",
    label: "+386"
  },
  {
    country_label: "Svalbard & Jan Mayen",
    code: "SJ",
    unicode: "&#x1F1F8;&#x1F1EF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SJ.svg",
    label: "+47"
  },
  {
    country_label: "Slovakia",
    code: "SK",
    unicode: "&#x1F1F8;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SK.svg",
    label: "+421"
  },
  {
    country_label: "Sierra Leone",
    code: "SL",
    unicode: "&#x1F1F8;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SL.svg",
    label: "+232"
  },
  {
    country_label: "San Marino",
    code: "SM",
    unicode: "&#x1F1F8;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SM.svg",
    label: "+378"
  },
  {
    country_label: "Senegal",
    code: "SN",
    unicode: "&#x1F1F8;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SN.svg",
    label: "+221"
  },
  {
    country_label: "Somalia",
    code: "SO",
    unicode: "&#x1F1F8;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SO.svg",
    label: "+252"
  },
  {
    country_label: "Suriname",
    code: "SR",
    unicode: "&#x1F1F8;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SR.svg",
    label: "+597"
  },
  {
    country_label: "South Sudan",
    code: "SS",
    unicode: "&#x1F1F8;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SS.svg",
    label: "+211"
  },
  {
    country_label: "São Tomé & Príncipe",
    code: "ST",
    unicode: "&#x1F1F8;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ST.svg",
    label: "+239"
  },
  {
    country_label: "El Salvador",
    code: "SV",
    unicode: "&#x1F1F8;&#x1F1FB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SV.svg",
    label: "+503"
  },
  {
    country_label: "Syria",
    code: "SY",
    unicode: "&#x1F1F8;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SY.svg",
    label: "+963"
  },
  {
    country_label: "Eswatini",
    code: "SZ",
    unicode: "&#x1F1F8;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/SZ.svg",
    label: "+268"
  },
  {
    country_label: "Turks & Caicos Islands",
    code: "TC",
    unicode: "&#x1F1F9;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TC.svg",
    label: "+1649"
  },
  {
    country_label: "Chad",
    code: "TD",
    unicode: "&#x1F1F9;&#x1F1E9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TD.svg",
    label: "+235"
  },
  {
    country_label: "Togo",
    code: "TG",
    unicode: "&#x1F1F9;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TG.svg",
    label: "+228"
  },
  {
    country_label: "Thailand",
    code: "TH",
    unicode: "&#x1F1F9;&#x1F1ED;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TH.svg",
    label: "+66"
  },
  {
    country_label: "Tajikistan",
    code: "TJ",
    unicode: "&#x1F1F9;&#x1F1EF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TJ.svg",
    label: "+992"
  },
  {
    country_label: "Tokelau",
    code: "TK",
    unicode: "&#x1F1F9;&#x1F1F0;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TK.svg",
    label: "+690"
  },
  {
    country_label: "Timor-Leste",
    code: "TL",
    unicode: "&#x1F1F9;&#x1F1F1;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TL.svg",
    label: "+670"
  },
  {
    country_label: "Turkmenistan",
    code: "TM",
    unicode: "&#x1F1F9;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TM.svg",
    label: "+993"
  },
  {
    country_label: "Tunisia",
    code: "TN",
    unicode: "&#x1F1F9;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TN.svg",
    label: "+216"
  },
  {
    country_label: "Tonga",
    code: "TO",
    unicode: "&#x1F1F9;&#x1F1F4;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TO.svg",
    label: "+676"
  },
  {
    country_label: "Turkey",
    code: "TR",
    unicode: "&#x1F1F9;&#x1F1F7;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TR.svg",
    label: "+90"
  },
  {
    country_label: "Trinidad & Tobago",
    code: "TT",
    unicode: "&#x1F1F9;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TT.svg",
    label: "+1868"
  },
  {
    country_label: "Tuvalu",
    code: "TV",
    unicode: "&#x1F1F9;&#x1F1FB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TV.svg",
    label: "+688"
  },
  {
    country_label: "Taiwan",
    code: "TW",
    unicode: "&#x1F1F9;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TW.svg",
    label: "+886"
  },
  {
    country_label: "Tanzania",
    code: "TZ",
    unicode: "&#x1F1F9;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/TZ.svg",
    label: "+255"
  },
  {
    country_label: "Ukraine",
    code: "UA",
    unicode: "&#x1F1FA;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UA.svg",
    label: "+380"
  },
  {
    country_label: "Uganda",
    code: "UG",
    unicode: "&#x1F1FA;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UG.svg",
    label: "+256"
  },
  {
    country_label: "United States",
    code: "US",
    unicode: "&#x1F1FA;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/US.svg",
    label: "+1"
  },
  {
    country_label: "Uruguay",
    code: "UY",
    unicode: "&#x1F1FA;&#x1F1FE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UY.svg",
    label: "+598"
  },
  {
    country_label: "Uzbekistan",

    code: "UZ",
    unicode: "&#x1F1FA;&#x1F1FF;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/UZ.svg",
    label: "+998"
  },
  {
    country_label: "Vatican City",
    code: "VA",
    unicode: "&#x1F1FB;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VA.svg",
    label: "+379"
  },
  {
    country_label: "St. Vincent & Grenadines",
    code: "VC",
    unicode: "&#x1F1FB;&#x1F1E8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VC.svg",
    label: "+1784"
  },
  {
    country_label: "Venezuela",
    code: "VE",
    unicode: "&#x1F1FB;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VE.svg",
    label: "+58"
  },
  {
    country_label: "British Virgin Islands",
    code: "VG",
    unicode: "&#x1F1FB;&#x1F1EC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VG.svg",
    label: "+1284"
  },
  {
    country_label: "U.S. Virgin Islands",
    code: "VI",
    unicode: "&#x1F1FB;&#x1F1EE;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VI.svg",
    label: "+1340"
  },
  {
    country_label: "Vietnam",
    code: "VN",
    unicode: "&#x1F1FB;&#x1F1F3;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VN.svg",
    label: "+84"
  },
  {
    country_label: "Vanuatu",
    code: "VU",
    unicode: "&#x1F1FB;&#x1F1FA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/VU.svg",
    label: "+678"
  },
  {
    country_label: "Wallis & Futuna",
    code: "WF",
    unicode: "&#x1F1FC;&#x1F1EB;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WF.svg",
    label: "+681"
  },
  {
    country_label: "Samoa",
    code: "WS",
    unicode: "&#x1F1FC;&#x1F1F8;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/WS.svg",
    label: "+685"
  },
  {
    country_label: "Yemen",
    code: "YE",
    unicode: "&#x1F1FE;&#x1F1EA;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YE.svg",
    label: "+967"
  },
  {
    country_label: "Mayotte",
    code: "YT",
    unicode: "&#x1F1FE;&#x1F1F9;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/YT.svg",
    label: "+262"
  },
  {
    country_label: "South Africa",
    code: "ZA",
    unicode: "&#x1F1FF;&#x1F1E6;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZA.svg",
    label: "+27"
  },
  {
    country_label: "Zambia",
    code: "ZM",
    unicode: "&#x1F1FF;&#x1F1F2;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZM.svg",
    label: "+260"
  },
  {
    country_label: "Zimbabwe",
    code: "ZW",
    unicode: "&#x1F1FF;&#x1F1FC;",
    image:
      "https://cdn.jsdelivr.net/npm/country-flag-emoji-json@2.0.0/dist/images/ZW.svg",
    label: "+263"
  }
];

export default countries;
